<div [style.width.px]="width" class="card"
  [ngClass]="{'card_le_l': (viewBreakpointService.size$ | async).less('l')}"
  >
  <h4>{{ 'term.sensors' | translate }}</h4>
  @for (sensor of unitData.getVisibleSensors(); track sensor.id) {
    <p>
      <span class="title">{{ sensor.nameTranslated }}: </span>
      <span class="text">{{ sensor.value | sensorValue: 2 }}&nbsp;{{ sensor.unitOfMeasure.nameTranslated }}</span>
    </p>
  }
</div>
